/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  useGATrack Hook
 */

import { useCallback } from 'react'

import { trackGAEvent } from '../utils/trackGAEvent'

export const useGATrack = (
  category: string,
  action: string,
  label?: string | number | null,
  value?: string,
  fields?: { nonInteraction?: boolean } & Record<string, unknown>
) => {
  const memoizedTrackEvent = useCallback(() => {
    trackGAEvent(category, action, label, value, fields)
  }, [category, action, label, value, fields])
  return memoizedTrackEvent
}
